/**
 * @fileoverview Row of trust-signal badges.
 * @description Renders the divider + wrapping row of TrustBadge pills shown at the bottom of the
 * login card (encryption/insurance/2FA signals).
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import TrustBadge from '@/shared/components/molecules/TrustBadge'

interface TrustBadgeListProps {
  items: { icon: string; label: string }[]
}

/**
 * @component
 * @param {TrustBadgeListProps} props - The badges to render.
 * @param {{icon: string, label: string}[]} props.items - Icon/label pairs, one per badge.
 */
function TrustBadgeList({ items }: TrustBadgeListProps) {
  return (
    <div className="mt-[26px] flex flex-wrap justify-center gap-3 border-t border-divider pt-[21px]">
      {items.map((item) => (
        <TrustBadge key={item.label} icon={item.icon} label={item.label} />
      ))}
    </div>
  )
}

export default TrustBadgeList
